import React from "react";
import Props from "prop-types";
import Close from "./close.png";
import {StateButton} from "../fStateButton";
import {Portal} from "../Portal";
import "./a.css";

function AiModal(props) {
    const handleBackdropClick = (e) => {
        // Only close if clicking directly on the backdrop element
        if (e.target === e.currentTarget) {
            props.close();
        }
    };
    
    return (
        <Portal>
            <div 
                className="modal fade show" 
                style={props.show ? { display: "block", background: 'rgba(0,0,0,.65)', zIndex: props.zIndex } : {}}
                onClick={handleBackdropClick}
            >
                <div 
                    className="modal-dialog ai-modal-animation" 
                    role="document" 
                    style={{ 
                        ...props.modalStyle,
                        maxWidth: (props.modalStyle &&  props.modalStyle.maxWidth) || '550px',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                        borderRadius: '16px',
                        overflow: 'hidden'
                    }}
                >
                    <div className="ai-modal-content-wrapper" onClick={(e) => e.stopPropagation()}>
                        <div className="ai-modal-gradient-overlay"></div>
                        <div className="ai-modal-gradient-overlay-2"></div>
                        <div className="ai-modal-gradient-overlay-3"></div>
                        <div className="ai-modal-shine-effect"></div>
                        <div className="ai-modal-header ai-modal-z-front">
                            <div className="ai-modal-title-container">
                                <div className="ai-modal-robot-icon">
                                    <i className="fa fa-robot" style={{fontSize: '12px', color: 'white'}}></i>
                                </div>
                                <h5 className="ai-modal-title" id="exampleModalLabel">
                                    {props.title}
                                </h5>
                            </div>
                            
                            {props.des && (
                                <div className="ai-modal-description-container">
                                    <p className="ai-modal-description">
                                        {props.des}
                                    </p>
                                </div>
                            )}
                            
                            <button 
                                type="button"
                                className="ai-modal-close-button"
                                onClick={props.close}
                                aria-label="Close"
                            >
                                <img alt="close" style={{ width: 12, height: 12 }} src={Close} />
                            </button>
                        </div>
                        
                        <div className="ai-modal-body ai-modal-z-front" style={props.modalBody}>
                            {props.children}
                        </div>
                        
                        {!props.hideFooter && (
                            <div className="ai-modal-footer ai-modal-z-front">
                                {!props.hideButton && (
                                    <button 
                                        className="ai-modal-button"
                                        style={props.style.save}
                                        onClick={props.stateLoading ? null : props.onSave}
                                    >
                                        {props.stateLoading ?
                                            <div style={{display:'flex', height:'inherit', justifyContent:'center', alignItems:'center'}}> 
                                                <StateButton /> 
                                            </div>
                                            : props.buttonName}
                                    </button>
                                )}
                            </div>
                        )}
                        
                        <div className="ai-modal-decorative-circle-1"></div>
                        <div className="ai-modal-decorative-circle-2"></div>
                    </div>
                </div>
            </div>
        </Portal>
    );
}

AiModal.propTypes = {
    onSave: Props.func,
    title: Props.string.isRequired,
    buttonName: Props.string,
    show: Props.bool,
    close: Props.func.isRequired,
    style: Props.object,
    hideButton: Props.bool,
    hideFooter: Props.bool,
    zIndex: Props.number
}

AiModal.defaultProps = {
    buttonName: "Apply AI Suggestions",
    hideButton: false,
    style: {
        close: {},
        save: {}
    },
    hideFooter: false,
    zIndex: 1050
}

export {
    AiModal
}; 